import styled from '@emotion/styled';

export const Page = styled.div`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: ${({ theme }): string => theme.color.grey100};
`;

export const Card = styled.form`
    padding: 32px;
    box-shadow: 0px 0px 30px 10px rgba(0, 0, 0, 0.1);
    border-radius: ${({ theme }) => theme.radius.main};
    background-color: ${({ theme }): string => theme.color.white100};
    width: 100%;
    max-width: 480px;
`;

export const Title = styled.h1`
    margin: 0 0 8px 0;
    font-size: ${({ theme }): string => theme.font.size.large};
    font-family: ${({ theme }): string => theme.font.family};
    font-weight: ${({ theme }): string => theme.font.weight.medium.toString()};
    text-align: center;
`;

export const Subtitle = styled.p`
    margin: 0 0 24px 0;
    font-size: ${({ theme }): string => theme.font.size.normal};
    color: ${({ theme }): string => theme.color.grey500};
    text-align: center;
`;

export const InputWrapper = styled.div`
    margin-bottom: 16px;
`;

export const CaptchaWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
`;

export const Actions = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SecondaryLink = styled.button`
    background: none;
    border: none;
    color: ${({ theme }): string => theme.color.primary};
    cursor: pointer;
    font-family: ${({ theme }): string => theme.font.family};
    font-size: ${({ theme }): string => theme.font.size.small};
    padding: 4px 0;
    text-decoration: underline;
`;

export const SuccessMessage = styled.p`
    margin: 0 0 16px 0;
    color: ${({ theme }): string => theme.color.black};
    text-align: center;
    font-size: ${({ theme }): string => theme.font.size.normal};
`;
